import React from 'react'
import { withRouter } from 'react-router'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './PaymentCardList.css'

const PaymentCardListUI = ({context, messageList, paymentCardList,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick}) =>
  <div className='c_cards'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick }
        />
      }
      right={
        <span />
      }
    />

    <LRTableBodyUI>
      {
        paymentCardList.map((paymentCard, i) =>
          <CustomerRowUI key={i} context={context} paymentCard={paymentCard}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({context, messageList, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick}) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
        <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_card' />
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        {
          selectedCount === 1 &&
          <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_users' />
        }
        <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_remove_users' />
      </div>
    }
  </React.Fragment>

const CustomerRowUI = ({context, messageList, paymentCard, onRowClick}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} paymentCard={paymentCard} onRowClick={onRowClick} />}
    right={<RowRightUI paymentCard={paymentCard} messageList={messageList} />}
    onClick={onRowClick}
    rowId={paymentCard.paymentCardId}
  />

const RowLeftUI = ({context, paymentCard, onRowClick}) =>
  <React.Fragment>
    {/* if React.Fragment is replaced with html element
      must add flex to the html element */}
    <input type="checkbox" className='checkbox' checked={paymentCard.selected} onChange={() => {}} />
    <label className='name'>
      {paymentCard.description}
    </label>
  </React.Fragment>

const RowRightUI = ({paymentCard, messageList}) =>
  <span />

export default withRouter(PaymentCardListUI)
